<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <error-msg-component :messages="messagesError"
                               :error="isError"
                               :messagesChampsVide="messagesChampsVide"
                               :champsVide="champsVide"
                               :title="'addEditCivilite.error.problemOccurred'"
                               :withEmplyFields="true"
                               @close="isError = $event"/>
      <section class="has-text-centered">
        <b-icon type="is-warning" icon="alert-outline" class="icon-modal"></b-icon>
        <p class="is-size-5 has-text-weight-bold">
        {{ messHeader }}
        </p>
      </section>
      <section class="mgt-10px">
        <div>
          <p v-if="isError"></p>
        </div>
        <b-field :label="$t('detailContrat.cloture.dateCloture')"
          class="mgt-20px" :type="isError ? 'is-danger' : ''">
          <b-datepicker show-week-number
              icon="calendar-today"
              :editable="true"
              nearby-selectable-month-days
              v-model="dateCloture"
              @input="VerifyInformation($event)">
          </b-datepicker>
        </b-field>
        <qd-switch v-model="isDeleteEchance" class="mgt-10px">
        {{ $t('detailContrat.cloture.deleteEcheance') }}
        </qd-switch>
      </section>
      <footer class="mgt-10px">
        <div class="has-text-centered">
        <button
            class="button btn-modal-annuler is-cancel has-text-centered button-modal"
            @click="$emit('close')">
            {{ $t('general.non') }}
        </button>
        <button class="button is-primary has-text-centered button-modal"
                :disabled="isError"
                @click="clotureContrat">
            {{ $t('general.oui') }}
        </button>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
import { cloture } from '@/api/baux/contrat';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import formatDateIso from '@/services/general/formatIsoDate';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import moment from 'moment';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/baux/contrat/translatorContrat';

export default {
  props: {
    contrat: {
      type: Object,
      required: true,
    },
    messHeader: {
      type: String,
      required: true,
    },
  },
  components: {
    errorMsgComponent,
  },
  data() {
    return {
      dateCloture: new Date(),
      isDeleteEchance: true,
      messagesChampsVide: [],
      champsVide: [],
      isError: false,
      messagesError: [],
    };
  },
  methods: {
    VerifyInformation(dateCloture) {
      this.isError = moment(dateCloture).isBefore(moment(this.contrat.dateDebutSignature));
      if (this.isError) {
        this.messagesError.push({ message: 'detailContrat.cloture.dateClotureInferieurDateDebutContrat' });
      }
    },
    async clotureContrat() {
      this.messagesChampsVide = [];
      this.champsVide = [];
      this.messages = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        await cloture(this.contrat.id, formatDateIso(this.dateCloture), this.isDeleteEchance);
        messageSucces(this.$i18n.t('detailContrat.cloture.successCloture'));
        this.$emit('reload');
        this.$parent.close();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        if (e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messagesError, this.messagesChampsVide, translate);
          this.isError = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
};
</script>
